import type { CheckResult } from "@/core/types";
import { Icon } from "./Icon";

interface CheckFeedbackProps {
  result: CheckResult;
  /** Nur bei Aufgaben, die diese Office-Version nicht prüfen kann. */
  onMarkDone?: () => void;
}

export function CheckFeedback({ result, onMarkDone }: CheckFeedbackProps) {
  const tone = result.passed ? "success" : result.unsupported ? "neutral" : "error";
  const icon = result.passed ? "check" : result.unsupported ? "info" : "alert";

  return (
    <div className={`feedback feedback--${tone}`} role="status" aria-live="polite">
      <p className="feedback__message">
        <span className="feedback__icon">
          <Icon name={icon} />
        </span>
        <span>{result.message}</span>
      </p>

      {result.criteria && result.criteria.length > 0 ? (
        <ul className="feedback__criteria">
          {result.criteria.map((criterion, index) => (
            <li
              key={criterion.label}
              className={criterion.passed ? "is-passed" : "is-open"}
              style={{ ["--i" as string]: index }}
            >
              {criterion.passed ? (
                <Icon name="check" size={14} />
              ) : (
                <span className="feedback__open" aria-hidden="true" />
              )}
              <span>
                <span className="visually-hidden">
                  {criterion.passed ? "Erfüllt: " : "Noch offen: "}
                </span>
                {criterion.label}
              </span>
            </li>
          ))}
        </ul>
      ) : null}

      {!result.passed && result.hint ? (
        <p className="feedback__hint">
          <Icon name="bulb" />
          <span>{result.hint}</span>
        </p>
      ) : null}

      {onMarkDone ? (
        <button type="button" className="text-button" onClick={onMarkDone}>
          Selbst als erledigt markieren
        </button>
      ) : null}
    </div>
  );
}
